import Vue from 'vue'
import App from './App'
import router from './router'
import Notification from '@/components/notification'
import '@/assets/stylus/index.styl'
import 'babel-polyfill'
import browserRedirect from '@/common/js/browserRedirect'
import i18n from './i18n/i18n';
import MetaInfo from 'vue-meta-info';
if (!window.location.href.includes('pcshow') && !window.location.href.includes('mobileshow')) {
  browserRedirect()
}


Vue.config.productionTip = false

Vue.use(Notification)
Vue.use(MetaInfo);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js